import React, { useState, useEffect } from 'react';
import ClipLoader from "react-spinners/ClipLoader";
import Comm from '../comm/comm';
import Tools from '../tools/tools';
import { toast } from 'react-toastify';
import ModalUpload from '../controls/ModalUpload';
import { Link, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import keycloak from '../tools/keycloak';



const MyJobs = (props) => {
    let [requests, setRequests] = useState([]);
    let [jobs, setJobs] = useState([]);
    let [show, setShow] = useState();



    const fetchData = async () => {
        Comm.Instance().get(`Dashboard/requests`).then(result => {
            setRequests(result.data);

        }).catch(error => {
            Tools.ProcessError(error);
        })
        Comm.Instance().get(`Dashboard/jobs`).then(result => {
            setJobs(result.data);

        }).catch(error => Tools.ProcessError(error))
    };
    useEffect(() => {


        fetchData();
    }, []);

    if (show) {
        sessionStorage.setItem("requestId", show.requestId);
        if (show.jobId) {
            return (<Redirect to={"RequestJob/" + show.jobId} />);
        }
        else {
            return (<Redirect to={"RequestMain/" + show.requestId} />);
        }
    }



    return (
        <div className="container">
            <h2 className="appeal-title mb-5">Мои преписки</h2>


            <div className="form-row">
                <div className="form-group col-md-12">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>
                                    Име
                                </th>
                                <th>

                                </th>

                            </tr>
                        </thead>
                        <tbody>
                            {
                                requests.map(i =>
                                    <tr key={i.requestId}>
                                        <td>
                                            <button className="btn btn-link" onClick={() => setShow({ requestId: i.requestId })}>{i.name}</button>
                                        </td>
                                        <td>
                                            {
                                                i.isLate &&
                                                <div className="alert alert-danger" role="alert">
                                                    Закъснение!</div>
                                            }
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>
            </div>

            <h2 className="appeal-title mb-5">Мои задачи</h2>


            <div className="form-row">
                <div className="form-group col-md-12">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>
                                    Преписка
                                    </th>
                                <th>
                                    Дейност
                                    </th>
                                <th>

                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                jobs.map(i =>
                                    <tr key={i.jobId}>
                                        <td>
                                            {i.requestName}
                                        </td>
                                        <td>
                                            <button className="btn btn-link" onClick={() => setShow({ requestId: i.requestId, jobId: i.jobId })}>{i.jobName}</button>
                                        </td>
                                        <td>
                                            {
                                                i.isLate &&
                                                <div className="alert alert-danger" role="alert">
                                                    Закъснение!</div>
                                            }
                                        </td>

                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

    );
}


export default MyJobs;

